// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-video-player/src/custom-theme.css
// module id = 5LIk
// module chunks = 25